import type { Tracker } from '@archipro-website/tracker';
import type { CreateEnquirySource } from '~/modules/enquiry';

interface SubmitCreateEnquiryRequestProps {
    source: CreateEnquirySource;
    isAutoSubmit?: boolean;
    /**
     * How far a bulk submission fans out. Absent for a single enquiry.
     *
     * This is the submit-attempt step the warehouse can actually see:
     * `EnquirySubmit` is on the ArchiPro pipeline's ignore list and never
     * arrives, so the counts belong here. Like `CreatedEnquiry`, it fires once
     * per submission however many professionals it reaches, so without them a
     * fifty-supplier send is indistinguishable from a single one.
     */
    fanOut?: { itemCount: number; supplierCount: number };
}

export const trackSubmitCreateEnquiryRequest = (
    tracker: Tracker,
    props: SubmitCreateEnquiryRequestProps,
) => {
    const { source, isAutoSubmit = false, fanOut } = props;
    const subSource = isAutoSubmit ? 'AutoSubmit' : 'EditEnquiryModal';
    void tracker.log('SubmitCreateEnquiryRequest', {
        url: new URL(window.location.href),
        data: {
            Source: `${source}-${subSource}`,
            ...(fanOut && {
                ExtraData: JSON.stringify({
                    bulk: true,
                    itemCount: fanOut.itemCount,
                    supplierCount: fanOut.supplierCount,
                }),
            }),
        },
    });
};
